export default __webpack_public_path__ + "static/media/chapterWebsite3Low.04eddb83.jpg";